exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1uizu{min-height:700px;position:relative}._2Hoec{max-width:1080px;margin-left:auto;margin-right:auto;padding-left:12px;padding-right:12px}.cT-O0{border-radius:0}._1cIm6{width:400px}.EIfSX{font-weight:700;color:#585858;font-family:Helvetica}._1NX6b{display:table;table-layout:fixed;width:100%}._3ud6P{padding:0}._1OtS_{margin-bottom:6px}.OCl61{margin-bottom:12px}._3qiqH{margin-bottom:18px}._1CsFE{margin-bottom:24px}.FPySv{margin-bottom:48px}._3r5E1{margin-top:6px}._2d_4T{margin-top:12px}._1drW9{margin-top:18px}._1jdTN{margin-top:24px}._1N8oW{margin-top:48px}._13RSS{float:right}._2IANP{border-color:#d9d9d9;background:#fff;color:#414243;margin-bottom:0;border-radius:4px;border:1px solid;text-align:center;vertical-align:middle;font-weight:700;line-height:1.43;white-space:normal;cursor:pointer;max-width:280px;width:100%;padding:5px 21px}._2IANP:focus,._2IANP:hover{border-color:#aaa;color:#414243;text-decoration:none}._2BbaE{border-color:ƒ;border-color:#149ce9;color:ƒ;color:#149ce9;background-color:#fff}._2BbaE:active,._2BbaE:active:focus,._2BbaE:active:hover,._2BbaE:focus,._2BbaE:hover{border-color:#ff7e82;color:#ff7e82;background-color:#fff}", ""]);

// exports
exports.locals = {
	"Container": "_1uizu",
	"containerResponsive": "_2Hoec",
	"receiptPanel": "cT-O0",
	"rowWidth": "_1cIm6",
	"textBold": "EIfSX",
	"rowTable": "_1NX6b",
	"noPadding": "_3ud6P",
	"space1": "_1OtS_",
	"space2": "OCl61",
	"space3": "_3qiqH",
	"space4": "_1CsFE",
	"space5": "FPySv",
	"spaceTop1": "_3r5E1",
	"spaceTop2": "_2d_4T",
	"spaceTop3": "_1drW9",
	"spaceTop4": "_1jdTN",
	"spaceTop5": "_1N8oW",
	"pullRight": "_13RSS",
	"button": "_2IANP",
	"btnPrimaryBorder": "_2BbaE"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Receipt/Receipt.css
// module id = 2556
// module chunks = 15